module.exports = __webpack_public_path__ + "static/media/myzithra.93b45106.jpg";